import { NavLink } from "react-router-dom";
import {
  BarChart2,
  ShoppingCart,
  DollarSign,
  TrendingUp,
  Calendar,
  Settings,
  HelpCircle
} from "lucide-react";
import SwiggyLogo from "../assets/Swiggy.png";
import ZomatoLogo from "../assets/Zomato-Logo.png";


import "../styles/sidebar.css";

export default function Sidebar() {
  return (
    <aside className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <span className="logo-icon">🍽</span>
        <span className="logo-text">Plattr</span>
      </div>

      {/* Main Navigation */}
      <nav className="sidebar-nav">
        <NavItem to="/overview" icon={<BarChart2 />} label="Overview" />
        <NavItem to="/orders"   icon={<img src={SwiggyLogo} alt="Swiggy" className="w-5 h-5" />} label="Swiggy Overview" />
        <NavItem to="/zomatoPerformance"   icon={<img src={ZomatoLogo} alt="Zomato" className="w-5 h-5" />} label="Zomato Overview" />
        <NavItem to="/reports" icon={<Calendar />} label="Platform Comparison" />
      </nav>

      <div className="sidebar-divider" />

      {/* Bottom Navigation */}
      <nav className="sidebar-nav bottom">
        {/* <NavItem to="/settings" icon={<Settings />} label="Settings" />
        <NavItem to="/help" icon={<HelpCircle />} label="Help" /> */}
      </nav>
    </aside>
  );
}

function NavItem({ to, icon, label }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive ? "nav-item active" : "nav-item"
      }
    >
      <span className="nav-icon">{icon}</span>
      <span className="nav-label">{label}</span>
    </NavLink>
  );
}

